import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { LiveProductsTitle } from "../../../../Constants/Constants";
import { LiveProductChart } from "../../../../Data/General/Widgets/Chart";

const LiveProducts = () => {
  return (
    <Col xl="7" lg="12" className="xl-50">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CommonCardHeader title={LiveProductsTitle} />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <ReactApexChart id="chart-widget6" options={LiveProductChart} series={LiveProductChart.series} type="area" height={320} />
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  );
};

export default LiveProducts;
